import React, { useState } from 'react';
import classnames from 'classnames';

export default function (props) {
  const { open, message } = props;
  return (
    <div className={classnames('toast', { open })}>
      <span className='message'>{message}</span>
    </div>
  );
}
